import React, { useState, useEffect } from "react";
import PageHeader from '../shared/pageHeader/PageHeader'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import Notes2Header from './Notes2Header'
import NotesCreate from './NotesCreate'
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
const EditNotes = () => {
          const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      const [permission, setPermission] = useState(null);
    
      useEffect(() => {
        const getPermission = async () => {
          const roleId = localStorage.getItem("roleId");
          const id = queryParams.get("id");
    
          const formData = new FormData();
          formData.append("role_id", roleId);
          formData.append("module_id", id);
    
          try {
            const result = await fetchFormData("get-permission", formData, "POST");
            const perm = result?.data;
    
            setPermission(perm);
    
          } catch (error) {
            console.error("Error fetching permission", error);
          }
        };
    
        getPermission();
      }, [id]);
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <Notes2Header permission={permission}/>
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <NotesCreate permission={permission}/>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default EditNotes